angular.module('impactx.search').controller('InkBarCtrl', [
    '$element',
    InkBarController
]);

function InkBarController($element) {
    var self = this;
    self.$onInit = function () {
        if (self.cardContainerCtrl) {
            self.cardContainerCtrl.setInkBar($element.find('span')[0]);
        }
        if (self.listContainerCtrl) {
            self.listContainerCtrl.setInkBar($element.find('span')[0]);
        }
    };

    self.$postLink = function () {
        if (self.cardContainerCtrl) {
            self.cardContainerCtrl.updateInkBar();
        }
        if (self.listContainerCtrl) {
            self.listContainerCtrl.updateInkBar();
        }
    };
}